import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import type { MetaGetter } from '@atlassian/jira-get-meta';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { State, NavigationTheme } from './types.tsx';

export const bootstrap =
	(): Action<
		State,
		{
			getMeta: MetaGetter;
		}
	> =>
	({ setState }, { getMeta }) => {
		const ajsBackgroundColor = getMeta('ajs-lf-navigation-bgcolour');
		const ajsHighlightColor = getMeta('ajs-lf-navigation-highlightcolour');
		// we need to use color code directly here to compare it with hex code in meta tags
		const hasNavv3CustomColors =
			ajsBackgroundColor != null &&
			ajsHighlightColor != null &&
			(ajsBackgroundColor !== colors.N0 || ajsHighlightColor !== colors.B400);

		const navigationTheme: NavigationTheme = {
			shouldShowTitle: getMeta('ajs-lf-top-adg3-shouldshowtitle') === 'true',
			logoUrl: getMeta('ajs-lf-top-adg3-logourl') || '',
			usesCustomColours: getMeta('ajs-lf-top-adg3-hascustomcolours') === 'true',
			backgroundColor: ajsBackgroundColor || token('color.background.inverse.subtle'),
			highlightColor: ajsHighlightColor || token('color.text.brand'),
		};

		if (hasNavv3CustomColors) {
			navigationTheme.usesCustomColours = true;
		}

		setState({ navigationTheme });
	};

export const update =
	(item: Partial<NavigationTheme>): Action<State> =>
	({ setState, getState }) => {
		const navigationTheme = { ...getState().navigationTheme, ...item };
		setState({
			navigationTheme,
		});
	};
